/**
 * Shows a generic "coupon applied" message inside the cart drawer's discount banner when the cart
 * is still empty -- Liquid has nothing to read from cart.cart_level_discount_applications at that
 * point (no items, no allocation), so this reads Shopify's discount_code cookie client-side instead,
 * the same way assets/coupon-discount-bar.js does for the sitewide slim bar. It never shows an
 * amount/percent, since that genuinely can't be resolved without an active cart.
 *
 * The moment something is added to the cart, the drawer re-renders server-side (see
 * snippets/cart-drawer.liquid) and the real, live-data branch in snippets/cart-discount-banner.liquid
 * takes over -- this script only has to handle the "before that" state.
 *
 * Liquid renders this placeholder whenever there's no active cart-level discount, which also
 * happens when the cart already has items but the discount was removed (e.g. at checkout) rather
 * than never applied -- that's not "before that" at all, so this checks the cart's real item count
 * before trusting the cookie, and clears it once it's confirmed stale.
 */
(function () {
  function getCookie(name) {
    const value = '; ' + document.cookie;
    const parts = value.split('; ' + name + '=');
    if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
    return null;
  }

  function clearCookie(name) {
    document.cookie = `${name}=; Max-Age=0; path=/;`;
  }

  // Shopify/Klaviyo append a random unique-code suffix to per-recipient discount links
  // (e.g. "SMSWELCOME10-SLCRSKSF") -- that suffix isn't meant to be customer-facing.
  function baseCode(code) {
    return (code || '').split('-')[0];
  }

  function escapeHTML(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function showFallback(banner) {
    const code = getCookie('discount_code');
    if (!code) return;

    fetch(`${window.routes ? window.routes.cart_url : '/cart'}.js`)
      .then((response) => response.json())
      .then((cart) => {
        if (cart.item_count > 0) {
          // The cart already has items but no discount is applied -- the discount was either never
          // valid or was removed (e.g. at checkout). The cookie doesn't reflect that on its own, so
          // clear it here instead of showing a confirmation for a discount that isn't there anymore.
          clearCookie('discount_code');
          return;
        }

        const message = banner.dataset.fallbackMessage || '';
        const showCode = banner.dataset.showCode === 'true';
        const codeHTML = showCode
          ? `<span class="cart-discount-banner__code">${escapeHTML(baseCode(code))}</span>`
          : '';

        banner.innerHTML = `<div class="cart-discount-banner__row"><span aria-hidden="true">&#10003;</span><span class="cart-discount-banner__text">${escapeHTML(message)} ${codeHTML}</span></div>`;
        banner.removeAttribute('hidden');
      })
      .catch(() => {});
  }

  function initAll() {
    document.querySelectorAll('[data-cart-discount-banner-empty]').forEach(showFallback);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // The drawer's contents get swapped wholesale on every cart update (add/remove/qty change), so
  // this needs to re-run against whatever fresh placeholder Liquid rendered this time.
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, initAll);
  }
})();
